module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-d8e7b748cc795da5e01274a5af48091d.png";